export default __webpack_public_path__ + "static/media/nft-container.9cf3c80d.png";